import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import useThumbnail from './useThumbnail';
import { ImageFull } from '../Gallery/wrapper';
import MediaButton from '../Gallery/MediaButton';
import Modal from '../Modal';
import VideoPlayer from './EmbeddedVideoLightbox';
import { onImageLoad, onImageError, isVideoPyrhon } from './utils';
import CustomPlayer from '../Video/CustomPlayer';
import PyrhonPlayer from './PhyronPlayer';

interface GalleryEmbed {
  src: string;
  index: number;
  controls?: boolean;
}

const GalleryEmbed = ({ src, index }: GalleryEmbed) => {
  const [modal, setModal] = useState<string>();
  const thumbnail = useThumbnail(src);

  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setModal(src);
  };

  const onCloseModal = (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    setModal(undefined);
  };

  const onError = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement, Event>) => onImageError(e, thumbnail),
    [thumbnail]
  );

  const onLoad = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement, Event>) => onImageLoad(e, thumbnail),
    [thumbnail]
  );

  const customVideo = src.toLowerCase().endsWith('.mp4');
  const pyrhonVideo = isVideoPyrhon(src) ? src?.replace('.mp4', '.jpg') : undefined;

  if (thumbnail?.length && !customVideo) {
    return (
      <>
        <ImageFull
          onLoad={onLoad}
          src={thumbnail[0]}
          onError={onError}
          alt={i18next.t('common.imageIndex', { index: index + 1 }) || ''}
        />
        <MediaButton text={i18next.t('other.playVideo')} onClick={onClick} />
        {modal && (
          <Modal title={i18next.t('other.video')} onClose={onCloseModal}>
            <VideoPlayer url={modal} />
          </Modal>
        )}
      </>
    );
  }

  if (customVideo)
    return (
      <>
        <CustomPlayer
          ratio="66.66%"
          isPreview
          controls={false}
          url={pyrhonVideo ? pyrhonVideo : src}
        />
        <MediaButton text={i18next.t('other.playVideo')} onClick={onClick} />
        {modal && (
          <Modal title={i18next.t('other.video')} onClose={onCloseModal}>
            {pyrhonVideo ? <PyrhonPlayer url={modal} /> : <VideoPlayer url={modal} />}
          </Modal>
        )}
      </>
    );
  return null;
};

export default GalleryEmbed;
